import AfterFetchComponent from '@/components/base/AfterFetchComponent'
import MemberAccountsGrid from "@/components/dashboard/customer-service/components/MemberAccountsGrid.vue";
import SearchEmployer from "@/components/dashboard/customer-service/components/SearchEmployer.vue";
import SearchMember from "@/components/dashboard/customer-service/components/SearchMember.vue";
import DepositsPanelComponent
  from "@/components/dashboard/find-member-or-employer/tabs/depositPanelEmployer/DepositsPanel.vue";
import EmployerGeneralDetails from "@/components/dashboard/find-member-or-employer/tabs/EmployerGeneralDetails.vue";
import MemberAllProcessGrid from "@/components/dashboard/find-member-or-employer/tabs/MemberAllProcessGrid.vue";
import MemberBeneficiaries from "@/components/dashboard/find-member-or-employer/tabs/MemberBeneficiaries.vue";
import CRMContactHistoryGrid from "@/components/dashboard/find-member-or-employer/tabs/MemberContactHistoryGrid.vue";
import MemberDocumentumGrid from "@/components/dashboard/find-member-or-employer/tabs/MemberDocumentumGrid.vue";
import MemberGeneralDetails from "@/components/dashboard/find-member-or-employer/tabs/MemberGeneralDetails.vue";
import MemberLoanGrids from "@/components/dashboard/find-member-or-employer/tabs/MemberLoanGrids.vue";
import MemberSecurities from "@/components/dashboard/find-member-or-employer/tabs/MemberSecurities.vue";
import MemberSubAccountsGrid from "@/components/dashboard/find-member-or-employer/tabs/MemberSubAccountsGrid.vue";
import MemberTransactionsGrid from "@/components/dashboard/find-member-or-employer/tabs/MemberTransactionsGrid.vue";
import ReportsTab
  from "@/components/dashboard/find-member-or-employer/tabs/searchEmployee/modalTabs/ReportsTab.component.vue";
import SearchEmployeeForEmployer
  from "@/components/dashboard/find-member-or-employer/tabs/searchEmployee/SearchEmployeeForEmployer.vue";
import WithdrawalAndTransfer from "@/components/dashboard/find-member-or-employer/tabs/WithdrawalAndTransfer.vue";
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {CrmFilterType} from "@/models/CrmFilterType";
import {ManagingCompanies} from "@/models/ManagingCompanies";
import {OprEntityKeys} from "@/models/OprEntityKeys";
import {EmployerCRMDetails, MemberCRMDetails, TabsConfiguration} from "@/store/modules/customerService";
import {KeyValuePair} from "@payroll/optimus-common";
import Component from 'vue-class-component'
import {Action, Getter} from "vuex-class";


@Component({
  components: {
    ReportsTab,
    MemberBeneficiaries,
    SearchMember,
    SearchEmployer,
    EmployerGeneralDetails,
    SearchEmployeeForEmployer,
    MemberAccountsGrid,
    MemberSubAccountsGrid,
    MemberTransactionsGrid,
    MemberLoanGrids,
    MemberGeneralDetails,
    CRMContactHistoryGrid,
    MemberDocumentumGrid,
    MemberSecurities,
    WithdrawalAndTransfer,
    DepositsPanelComponent,
    MemberAllProcessGrid,
  }
})
export default class FindMembersOrEmployersComponent extends AfterFetchComponent {
  @Action('getMemberDetails', StoreNamespace.CUSTOMER_SERVICE) getMemberDetails: any;
  @Action('getEmployerDetails', StoreNamespace.CUSTOMER_SERVICE) getEmployerDetails: any;
  @Action('getSubAccounts', StoreNamespace.CUSTOMER_SERVICE) getSubAccounts: any;
  @Action('getRestrictions', StoreNamespace.CUSTOMER_SERVICE) getRestrictions: any;
  @Action('getTabsConfiguration', StoreNamespace.CUSTOMER_SERVICE) getTabsConfiguration: any;
  @Action('getMemberDocumentumConfig', StoreNamespace.CUSTOMER_SERVICE) getMemberDocumentumConfig: any;
  @Getter('mngCompanyName', StoreNamespace.AUTHENTICATION) mngCompanyName!: string
  @Getter('oprEntityKey', StoreNamespace.AUTHENTICATION) oprEntityKey!: number

  private lastEntitySelected: string = ""
  private lastCrmFilterType: CrmFilterType | null = null

  private memberCRMDetails: MemberCRMDetails | null = null;
  private employerCRMDetails: EmployerCRMDetails | null = null;
  private memberAccounts: any[] | undefined = []
  private memberFundTypes: any[] | undefined = []
  private memberSubAccounts: any = null
  private showSubAccountSpinner: boolean = false;
  private selectedAccountNum: string = ""
  private showSecuritiesSection: boolean = false
  private showDocumentumSection: boolean = false
  private accountList: KeyValuePair[] = []
  private reportTypes: KeyValuePair[] = []
  private dataYearFromList: KeyValuePair[] = []
  private restrictions: string[] = []
  private title: string = ''

  private tabsConfiguration: TabsConfiguration = {
    generalDetailsFlag: false,
    accountDetailsFlag: false,
    customerServiceFlag: false,
    accountTransactionsFlag: false,
    transfersWithdrawalsFlag: false,
    beneficiariesFlag: false,
    securitiesFlag: false,
    employeeListForEmployerFlag: false,
    depositsForEmployerFlag: false,
    archiveDocumentsFlag: false,
    processStatusFlag: false,
    loansFlag: false,
  };

  private memberOrEmployerTabIndex: number = 0

  mounted() {
    if (this.isGlobalNet()) {
      this.showSecuritiesSection = true;
    }

    this.getTabsConfiguration({
      requestorCallback: this,
    })
  }

  onSuccess(data?: any, requestName?: string, message?: string, success?: boolean): void {
    switch (requestName) {
      case 'getMemberDetails':
        this.memberCRMDetails = data;
        this.memberAccounts = []
        if (this.memberCRMDetails) {
          this.memberAccounts = this.memberCRMDetails.accountsList
          this.memberFundTypes = this.memberCRMDetails.fundTypeList
        }

        this.getMemberDocumentumConfig({
          pathVariable: this.memberCRMDetails?.personalId,
          requestorCallback: this
        })
        break;

      case 'getEmployerDetails':
        this.employerCRMDetails = data
        break;
      case 'findMembersOrEmployersFor/subAccounts':
        this.showSubAccountSpinner = false;
        this.memberSubAccounts = data
        break;

      case 'findMembersOrEmployersFor/restrictions':
        this.restrictions = data.restrictions
        break;

      case 'findMembersOrEmployersFor/memberDocumentumConfig':
        if (data.hasDocumentum) {
          this.showDocumentumSection = true;
          this.accountList = data.accountList;
          this.reportTypes = data.reportTypes;
          this.dataYearFromList = data.dataYearFromList;
        }
        break;

      case 'findMembersOrEmployersFor/tabsConfiguration':
        this.tabsConfiguration = data
        break;
    }
  }


  private onSelectedMember(member: any) {
    this.lastEntitySelected = member.id
    this.lastCrmFilterType = CrmFilterType.MEMBER
    this.title = `${this.$t('FindMembersOrEmployers.memberTitle').toString()} - ${member.fullName} (${member.idNumber})`

    this.getMemberDetails({
      pathVariable: member.id,
      requestorCallback: this
    })
  }

  private onSelectedEmployer(employer: any) {
    this.lastEntitySelected = employer.id
    this.lastCrmFilterType = CrmFilterType.EMPLOYER
    this.title = `${this.$t('FindMembersOrEmployers.employerTitle').toString()} - ${employer.employerName} (${employer.employerHp})`

    this.getEmployerDetails({
      pathVariable: employer.id,
      requestorCallback: this
    })
  }

  private onSelectedMemberAccount(accountDetails: any) {
    this.restrictions = []
    this.memberSubAccounts = null
    this.selectedAccountNum = accountDetails.accountNum
    this.showSubAccountSpinner = true

    this.getSubAccounts({
      pathVariable: accountDetails.accountNumHashed,
      requestorCallback: this
    })

    this.getRestrictions({
      pathVariable: accountDetails.accountNumHashed,
      requestorCallback: this
    })
  }

  private isGlobalNet() {
    return this.mngCompanyName === ManagingCompanies.GLOBAL_NET.toLowerCase()
  }

  private onClickGoBack() {
    if (this.lastCrmFilterType === CrmFilterType.MEMBER) {
      this.memberOrEmployerTabIndex = 0;
    } else {
      this.memberOrEmployerTabIndex = 1;
    }

    this.title = ""
    this.memberCRMDetails = null;
    this.employerCRMDetails = null
    this.memberAccounts = []
    this.restrictions = []
    this.memberSubAccounts = null
  }

  private afterSuccessPersonalDetailsUpdate(isMember: boolean) {
    this.onClickGoBack()

    if (isMember) {
      this.getMemberDetails({
        pathVariable: this.lastEntitySelected,
        requestorCallback: this
      });
    } else {
      this.getEmployerDetails({
        pathVariable: this.lastEntitySelected,
        requestorCallback: this
      })
    }

    this.showAfterSuccessfullyActionPopup(this.$t('FindMembersOrEmployers.successUpdateMessage').toString())
  }

  private showAfterSuccessfullyActionPopup(message: string) {
    this.$root.$emit('showAlertNotification', {
      toShow: true,
      message: message,
      icon: 'checkCircle',
      secondsToDisappear: 3
    })
  }

  private isOprEntityHapoalim(): boolean {
    return this.oprEntityKey === OprEntityKeys.BANK_HAPOALIM;
  }

}
